import authenticated from './http-clients/authenticated'

const _url = '/users/me'

export default {
  getMe () {
    return authenticated({
      url: _url,
      method: 'get'
    })
  },

  updateMe({ data }) {
    return authenticated({
      url: _url,
      method: 'patch',
      data
    })
  },

  resendConfirmation() {
    return authenticated({
      url: `${_url}/notifications/confirm-email`,
      method: 'post'
    })
  },

  requestAccess({ data }) {
    return authenticated({
      url: '/access-requests',
      method: 'post',
      data
    })
  },

  favoriteTopics (params) {
    let url = `tenants/${params.tenantID}/my-membership/favorite-topics?`

    if (typeof(params.paginate) !== 'undefined' && params.paginate !== null) {
      url = `${url}&paginate=${params.paginate}`
    }
    if (typeof(params.active) !== 'undefined' && params.active !== null) {
      url = `${url}&active=${params.active}`
    }
    if (typeof(params.archived) !== 'undefined' && params.archived !== null) {
      url = `${url}&archived=${params.archived}`
    }
    if (typeof(params.order) !== 'undefined' && params.order !== null) {
      url = `${url}&order=${params.order}`
    }
    if (typeof(params.desc) !== 'undefined' && params.desc !== null) {
      url = `${url}&desc=${params.desc}`
    }
    if (typeof(params.search) !== 'undefined' && params.search !== null) {
      url = `${url}&search=${params.search}`
    }
    if (typeof(params.page) !== 'undefined' && params.page !== null) {
      url = `${url}&page=${params.page}`
    }

    return authenticated({
      url,
      method: 'get'
    })
  },

  contentTree ({tenantID}) {
    return authenticated({
      url: `tenants/${tenantID}/my-membership/content-tree`,
      method: 'get'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/client.js